<div [ngClass]="{ 'mb-7': !noMargin }" [attr.data-cy]="label + '-widget'">
  <div
    class="flex justify-content-between align-items-start sm:align-items-center mt-0 mb-3 sm:mb-4"
    [attr.data-cy]="label + '-container'"
  >
    <div class="flex flex-column sm:flex-row sm:align-items-center">
      <h3 class="m-0" [innerHtml]="title" [attr.data-cy]="label + '-heading'"></h3>
      <p-tag
        *ngIf="pendingVerification"
        value="Pending Verification"
        severity="warning"
        styleClass="mx-0 my-1 sm:ml-5 sm:mr-1 p-tag-sm"
        [attr.data-cy]="label + '-pending-verification-tag'"
      ></p-tag>
    </div>
    <button
      *ngIf="!disableChange"
      pButton
      type="button"
      label="Change"
      icon="mi-round mi-edit"
      class="p-button-text p-button-sm"
      (click)="handleStepChange()"
      [attr.data-cy]="label + '-change-button'"
      appClickEvent
      eventName="order_wizard_summary_change_info"
      [eventParams]="{ navigate_back_to: title }"
    ></button>
  </div>
  <p-divider></p-divider>
  <ng-content></ng-content>
</div>
